<template>
    <pl-popper v-bind="popperBinding"
               ref="popper"
               @mounted="e=>p_popper=e"
               @open="pl_open"
               @close="pl_close"

               @show="pl_show"
               @hide="pl_hide"
    >
        <lv-scroll :scrollbar-size="6" ref="scroll" v-bind="scrollBinding">
            <slot></slot>
        </lv-scroll>
    </pl-popper>
</template>

<script>

    import PlDom from "../dom/pl-dom";
    import PlPopper from "../popper/pl-popper";
    import LvScroll from "../scroll/lv-scroll";

    export default {
        name: "pl-popover",
        components: {LvScroll, PlPopper, PlDom},
        props: {
            value: {},
            reference: {},
            popper: {},
            scroll: {},

            defaultPopper: {
                default: () => ({})
            },
        },
        data() {
            return {
                p_popper: null,
                p_show: null,
            }
        },
        watch: {
            value(val) {
                !!val ? this.show() : this.hide()
            },
        },
        computed: {
            popperBinding() {
                return Object.assign({
                    reference: this.reference,
                }, this.defaultPopper, this.popper)
            },
            scrollBinding() {
                return Object.assign({
                    scrollX: false,
                    fitHostWidth: true,
                    ...(this.scroll || {})
                })
            },
        },
        mounted() {
            if (!!this.value) this.show()
        },
        methods: {
            show() {
                this.p_popper.show()
            },
            hide() {
                this.p_popper.hide()
            },
            toggle() {
                this.p_popper.toggle()
            },
            pl_open(e) {
                this.$emit('open', e)
            },
            pl_close(e) {
                this.$emit('close', e)
                this.$emit('input', false)
                this.p_show = false
            },
            pl_show(e) {
                this.$emit('show', e)
                this.$emit('input', true)
                this.p_show = true
                this.$refs.scroll.refreshSize()
            },
            pl_hide(e) {
                this.$emit('hide', e)
            },
        },
    }
</script>

<style lang="scss">

</style>
